export class tMaterialModel {
    
    ID: number;
    materialDesc: string;
    materialDescENG: string;
    materialCatID:number;
    materialCatName:string;
    unitID:number;
    unitDesc:string;
    shopID: number;
    lastModifyDatetime: Date;
    lastModifyUserID: string;
    inActive: string;

}





